<template>
  <div class="banner-wrapper">
    <div class="banner">
      <div class="banner-header">
        <header-menu />
      </div>
      <div class="banner-body">
        <span>
          логистика
        </span>
        <strong>
          Таврии
        </strong>
        <div class="banner-body-line" />
        <p>Доставка сборных грузов</p>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderMenu from '@/components/HeaderMenu'
export default {
  name: 'THeader',
  components: {HeaderMenu},
}
</script>

<style scoped>
.banner-wrapper {
  width: 100%;
  padding-top: min(max(66%, 590px), 720px);
  position: relative;
  background-size: cover;
  background-image: url("../assets/banner.png");
  background-position: center;
}
.banner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: max(100%, 590px);
  /*min-height: 590px;*/
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  color: white;
}

.banner > div {
  width: 97%;
  max-width: 1240px;
}

.banner-body {
  height: 100%;
  border: 1px solid #999;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
}
.banner-body > span {
  font-size: 52px;
  line-height: 1;
  font-weight: 600;
}
.banner-body > strong {
  font-size: 82px;
  line-height: 1;
  font-weight: 900;
  color: var(--primary-color);
}
.banner-body > p {
  font-size: 28px;
  margin: 0;
}
.banner-body-line {
  width: 40px;
  height: 10px;
  background-color: var(--primary-color);
  margin-top: 26px;
  margin-bottom: 16px;
}

@media screen and (max-width: 480px) {
  .banner-wrapper {
    background-size: auto 160%;
    background-position: 62% 65%;
  }
  .banner-body > span {
    font-size: min(12vw, 40px);
  }
  .banner-body > strong {
    font-size: min(18vw, 60px);
  }
}
</style>
